module.exports = __webpack_public_path__ + "img/icon10.ae50b393.png";